import { useCallback, useEffect, useMemo, useState } from "react";
import { isEqual } from "lodash";
import {
  Button,
  Group,
  LoadingOverlay,
  Stack,
  TextInput,
  NumberInput,
  ActionIcon,
  Title,
  Breadcrumbs,
  Anchor,
  Select,
  ColorInput,
  Text,
  Textarea,
  Divider,
  Modal,
  Switch,
} from "@mantine/core";
import { List, ThemeIcon } from "@mantine/core";
import { Edit, GripVertical } from "tabler-icons-react";
import { v4 as uuidv4 } from "uuid";

//import { zodResolver } from "mantine-form-zod-resolver";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDebug } from "common/debug/hooks/useDebug";
import {
  useAddPronosticV2Mutation,
  useRemovePronosticV2Mutation,
  useUpdatePronosticV2Mutation,
} from "pronosticsv2/api/pronosticv2.api";
import {
  PronosticV2FormProvider,
  usePronosticV2Form,
} from "pronosticsv2/context/pronosticv2.context";

//import { pronosticV2Schema } from "pronosticsv2/admin/components/forms/PronosticV2Schema";
import Collapsable from "common/admin/ui/Collapsable";
import { DatePicker, TimeInput } from "@mantine/dates";
import {
  Player,
  PronosticV2,
  PronosticV2Element,
  PronosticV2Results,
  PronosticV2Winner,
  SlideShowElement,
  WinConditionPointsCalcConfig,
  isInputLikeElement,
} from "pronosticsv2/types/pronosticv2.model";

import { CirclePlus, Copy, Trash } from "tabler-icons-react";
import { ADMIN_PATH } from "_urls";
import {
  ADMIN_ORGANIZATION,
  ORGANIZATIONS,
  PRONOSTICSV2_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS,
  PRONOSTICSV2_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES,
} from "_roles";
import { useOrganization } from "common/admin/auth/hooks";
import { useListPlacesQuery } from "place/api/place.api";
import FileInput from "common/admin/ui/FileInput";
import { SubPlaceAdditionForm } from "./SubPlaceAdditionForm";
import { GenericTable } from "../GenericTable";
import { SubPlace } from "place/types/place.model";
import { SubPlaceEditForm } from "./SubPlaceEditForm";
import { PronosticV2Service } from "services/pronosticv2.service";
import { AccessRights } from "common/admin/auth/AccessRights";
import { PlayerQueryBySubPlaces } from "../PlayerQueryBySubPlaces";
import { StaffAdditionForm } from "./StaffAdditionForm";
import { useListWorkforcesQuery } from "workforce/admin/workforce.api";
//import { is } from "@react-spring/shared";
// import { usePronosticsV2 } from "pronosticsv2/hooks/usePronosticsV2";

export function Pronosticv2AdminForm({
  pronostic,
  editMode,
}: {
  pronostic?: PronosticV2;
  editMode: boolean;
}) {
  const { isDebugMode, log } = useDebug();

  // const { refetchPronosticV2: refetchPronostics } = usePronosticsV2();
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  // const handleRefrehPronosticV2 = () => {
  //   try {
  //     console.log("Refetching pronostic");
  //     refetchPronostics();
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  //console.log("results", pronostic?.specificSettings.pronosticResults);
  const location = useLocation();
  const navigate = useNavigate();
  const [opened, setOpened] = useState(false);
  const [opened1, setOpened1] = useState(false);
  const [opened4, setOpened4] = useState(false);
  const [opened5, setOpened5] = useState(false);
  const [editingSlideshowIndex, setEditingSlideshowIndex] = useState<
    number | null
  >(null);
  const [subPlaceTitle, setSubPlaceTitle] = useState("");
  const [subPlaceId, setSubPlaceId] = useState("");
  const [computeError, setComputeError] = useState("");
  void computeError;
  const [newPointsCalcType, setNewPointsCalcType] = useState<
    "FourWeights" | "DistanceCalculation" | "ExactMatch"
  >("FourWeights");

  const [addPronostic, addPronosticResult] = useAddPronosticV2Mutation();
  const [deletePronosticV2] = useRemovePronosticV2Mutation();

  const [updatePronostic, updatePronosticResult] =
    useUpdatePronosticV2Mutation();
  const [isLoading, setIsLoading] = useState(false);

  const { data: places = [], isLoading: loadingPlaces } = useListPlacesQuery();
  const { data: workforces = [], isLoading: loadingWorkforces } =
    useListWorkforcesQuery();

  const [organization] = useOrganization();
  const isDuplicate = location.pathname.endsWith("/duplicate");
  const [newPronosticType, setNewPronosticType] = useState("input");

  useEffect(() => {
    if (isDebugMode) {
      if (addPronosticResult.isError) {
        log(`Add error: ${JSON.stringify(addPronosticResult.error)}`);
      }
      if (updatePronosticResult.isError) {
        log(`Update error: ${JSON.stringify(updatePronosticResult.error)}`);
      }
    }
  }, [isDebugMode, addPronosticResult, updatePronosticResult, log]);

  // useEffect(() => {
  //   handleRefrehPronosticV2();
  // }, [opened1]);
  // console.log("isDuplicate", isDuplicate);

  const getInitialValues = useCallback(() => {
    if (pronostic && editMode) {
      return {
        partitionId: pronostic.partitionId || "",
        parentId: isDuplicate ? pronostic.id : "",
        name: isDuplicate ? `${pronostic.name} (copy)` : pronostic.name || "",
        status: isDuplicate
          ? "not started"
          : (pronostic.status as "not started" | "ongoing" | "closed"),
        type: pronostic.type || "",
        createdAt: isDuplicate
          ? new Date().toISOString()
          : pronostic.createdAt || new Date().toISOString(),
        header: {
          html: pronostic.header?.html || "",
          enabled: pronostic.header?.enabled || false,
        },
        owner: {
          L1: pronostic.owner?.L1 || organization || "",
          L2: pronostic.owner?.L2 || "",
          L3: pronostic.owner?.L3 || "",
          L4: pronostic.owner?.L4 || "",
        },
        commonSettings: {
          general: {
            moduleSettings: {
              place: pronostic.commonSettings?.general?.moduleSettings
                ?.place || {
                placeId: "",
                placeTitle: "",
                subPlaces: [],
              },
              pronostics:
                pronostic.commonSettings?.general?.moduleSettings?.pronostics ||
                [],
              winCondition: pronostic.commonSettings?.general?.moduleSettings
                ?.winCondition || {
                type: "",
                content: [],
              },
            },
          },
          webApp: {
            moduleSettings: {
              messageTitleColor:
                pronostic.commonSettings?.webApp?.moduleSettings
                  ?.messageTitleColor || "#000000",
              messageTitleSize:
                pronostic.commonSettings?.webApp?.moduleSettings
                  ?.messageTitleSize || "16px",
              pronoTitleColor:
                pronostic.commonSettings?.webApp?.moduleSettings
                  ?.pronoTitleColor || "#000000",
              pronoTitleSize:
                pronostic.commonSettings?.webApp?.moduleSettings
                  ?.pronoTitleSize || "16px",
              buttonBgColor:
                pronostic.commonSettings?.webApp?.moduleSettings
                  ?.buttonBgColor || "#000000",
              buttonTextColor:
                pronostic.commonSettings?.webApp?.moduleSettings
                  ?.buttonTextColor || "#FFFFFF",
              mandatoryTextColor:
                pronostic.commonSettings?.webApp?.moduleSettings
                  ?.mandatoryTextColor || "#000000",
              mandatoryTextSize:
                pronostic.commonSettings?.webApp?.moduleSettings
                  ?.mandatoryTextSize || "14px",
              rankingPageTitleSize:
                pronostic.commonSettings?.webApp?.moduleSettings
                  ?.rankingPageTitleSize || "16px",
              rankingPageTitleColor:
                pronostic.commonSettings?.webApp?.moduleSettings
                  ?.rankingPageTitleColor || "#000000",
              rankingPageBorderColor:
                pronostic.commonSettings?.webApp?.moduleSettings
                  ?.rankingPageBorderColor || "#000000",
              backGroundPosition:
                pronostic.commonSettings?.webApp?.moduleSettings
                  ?.backGroundPosition || "left",
            },
            medias: {
              backGroundImage:
                pronostic.commonSettings?.webApp?.medias?.backGroundImage || "",
            },
            texts: {
              welcomeMessage:
                pronostic.commonSettings?.webApp?.texts?.welcomeMessage || "",
              footerMessage:
                pronostic.commonSettings?.webApp?.texts?.footerMessage || "",
              thankYouMessage:
                pronostic.commonSettings?.webApp?.texts?.thankYouMessage || "",
              noResultMessage:
                pronostic.commonSettings?.webApp?.texts?.noResultMessage || "",
              notStartedMessage:
                pronostic.commonSettings?.webApp?.texts?.notStartedMessage ||
                "",
              tooLateMessage:
                pronostic.commonSettings?.webApp?.texts?.tooLateMessage || "",
              mandatoryMessage:
                pronostic.commonSettings?.webApp?.texts?.mandatoryMessage || "",
              submitButtonLabel:
                pronostic.commonSettings?.webApp?.texts?.submitButtonLabel ||
                "",
              backHomeButtonLabel:
                pronostic.commonSettings?.webApp?.texts?.backHomeButtonLabel ||
                "",
              resultsButtonLabel:
                pronostic.commonSettings?.webApp?.texts?.resultsButtonLabel ||
                "",
              refreshButtonLabel:
                pronostic.commonSettings?.webApp?.texts?.refreshButtonLabel ||
                "",
              subPlacePrefixTitle:
                pronostic.commonSettings?.webApp?.texts?.subPlacePrefixTitle ||
                "",
              rankingPageTitle:
                pronostic.commonSettings?.webApp?.texts?.rankingPageTitle || "",
            },
          },
          publicSharing: {
            moduleSettings: {
              messagesColor:
                pronostic.commonSettings?.publicSharing?.moduleSettings
                  ?.messagesColor || "#000000",
              messagesSize:
                pronostic.commonSettings?.publicSharing?.moduleSettings
                  ?.messagesSize || "16px",
              screenTopMargin:
                pronostic.commonSettings?.publicSharing?.moduleSettings
                  ?.screenTopMargin || "0px",
              screenLeftMargin:
                pronostic.commonSettings?.publicSharing?.moduleSettings
                  ?.screenLeftMargin || "0px",
            },
            medias: {
              backgroundImage:
                pronostic.commonSettings?.publicSharing?.medias
                  ?.backgroundImage || "",
              sponsorImage:
                pronostic.commonSettings?.publicSharing?.medias?.sponsorImage ||
                "",
            },
            texts: {
              introductionMessage:
                pronostic.commonSettings?.publicSharing?.texts
                  ?.introductionMessage || "",
            },
          },
        },
        specificSettings: {
          beginAt:
            pronostic.specificSettings?.beginAt || new Date().toISOString(),
          endAt:
            pronostic.specificSettings?.endAt ||
            new Date(Date.now() + 86400000).toISOString(), // +1 day
          pronosticResults: isDuplicate
            ? []
            : pronostic.specificSettings?.pronosticResults || [],
          resultsPublication: isDuplicate
            ? false
            : pronostic.specificSettings?.resultsPublication || false,
          winnersInfo: isDuplicate
            ? []
            : pronostic.specificSettings?.winnersInfo || [],
        },
      };
    }

    return {
      partitionId: "",
      parentId: "",
      name: "",
      status: "not started" as "not started" | "ongoing" | "closed",
      type: "",
      createdAt: new Date().toISOString(),
      header: {
        html: "",
        enabled: false,
      },
      owner: {
        L1: organization || "",
        L2: "",
        L3: "",
        L4: "",
      },
      commonSettings: {
        general: {
          moduleSettings: {
            place: {
              placeId: "",
              placeTitle: "",
              subPlaces: [],
            },
            pronostics: [],
            winCondition: {
              type: "",
              content: [],
            },
          },
        },
        webApp: {
          moduleSettings: {
            messageTitleColor: "#000000",
            messageTitleSize: "16px",
            pronoTitleColor: "#000000",
            pronoTitleSize: "16px",
            buttonBgColor: "#000000",
            buttonTextColor: "#FFFFFF",
            mandatoryTextColor: "#000000",
            mandatoryTextSize: "14px",
            rankingPageTitleSize: "16px",
            rankingPageTitleColor: "#000000",
            rankingPageBorderColor: "#000000",
            backGroundPosition: "left",
          },
          medias: {
            backGroundImage: "",
          },
          texts: {
            welcomeMessage: "",
            footerMessage: "",
            thankYouMessage: "",
            noResultMessage: "",
            notStartedMessage: "",
            tooLateMessage: "",
            mandatoryMessage: "",
            submitButtonLabel: "",
            backHomeButtonLabel: "",
            resultsButtonLabel: "",
            refreshButtonLabel: "",
            subPlacePrefixTitle: "",
            rankingPageTitle: "",
          },
        },
        publicSharing: {
          moduleSettings: {
            messagesColor: "#000000",
            messagesSize: "16px",
            screenTopMargin: "0px",
            screenLeftMargin: "0px",
          },
          medias: {
            backgroundImage: "",
            sponsorImage: "",
          },
          texts: {
            introductionMessage: "",
          },
        },
      },
      specificSettings: {
        beginAt: new Date().toISOString(),
        endAt: new Date(Date.now() + 86400000).toISOString(), // +1 day
        pronosticResults: [],
        resultsPublication: false,
        winnersInfo: [],
      },
    };
  }, [pronostic, editMode, isDuplicate, organization]);

  const form = usePronosticV2Form({
    initialValues: getInitialValues(),
    //validate: zodResolver(pronosticV2Schema),
  });

  const isDirty = useMemo(
    () => !isEqual(form.values, getInitialValues()),
    [form.values, getInitialValues]
  );

  // Initialize existing pronostics with type if needed
  useEffect(() => {
    const pronostics =
      form.values.commonSettings.general.moduleSettings.pronostics;
    if (pronostics.length > 0 && !pronostics[0].type) {
      // Convert existing pronostics to new structure with type
      const updatedPronostics = pronostics.map((pronostic) => ({
        ...pronostic,
        type: "input", // Set default type for existing items
      }));

      form.setFieldValue(
        "commonSettings.general.moduleSettings.pronostics",
        updatedPronostics
      );
    }
  }, [form.values.commonSettings.general.moduleSettings.pronostics, form]);

  // Handler for adding a new pronostic element
  // const handleAddPronosticElement = () => {
  //   const current =
  //     form.values.commonSettings.general.moduleSettings.pronostics;

  //   // if (current.length > 0) {
  //   //   const lastElement = current[current.length - 1];
  //   //   if (!lastElement.type || !lastElement.element1Title) {
  //   //     return;
  //   //   }
  //   // }

  //   const newElement = {
  //     index: current.length + 1,
  //     type: "",
  //     element1Title: "",
  //     element2Visual: "",
  //     element3Title: "",
  //     element4FieldSize: 2,
  //     element5FieldSize: 2,
  //     element6Title: "",
  //     element7Visual: "",
  //   };

  //   form.setFieldValue("commonSettings.general.moduleSettings.pronostics", [
  //     ...current,
  //     newElement,
  //   ]);
  // };

  const handleAddPronosticElement = (type = "input") => {
    const newIndex =
      form.values.commonSettings.general.moduleSettings.pronostics.length + 1;

    if (type === "slideshow") {
      const newSlideshow: SlideShowElement = {
        index: newIndex,
        type: "slideshow",
        title: "",
        player: [], // Initialize with empty array
        workforceId: "", // Add workforceId
      };

      form.setFieldValue("commonSettings.general.moduleSettings.pronostics", [
        ...form.values.commonSettings.general.moduleSettings.pronostics,
        newSlideshow,
      ]);
    } else {
      const newPronostic: PronosticV2Element = {
        index: newIndex,
        type: type as "" | "input",
        element1Title: "",
        element2Visual: "",
        element3Title: "",
        element4FieldSize: 0,
        element5FieldSize: 0,
        element6Title: "",
        element7Visual: "",
      };

      form.setFieldValue("commonSettings.general.moduleSettings.pronostics", [
        ...form.values.commonSettings.general.moduleSettings.pronostics,
        newPronostic,
      ]);
    }
  };

  // console.log(
  //   "win conditons",
  //   form.values.commonSettings.general.moduleSettings.winCondition,
  // );

  const handleDuplicatePronosticElement = (index: number) => {
    const pronostics = [
      ...form.values.commonSettings.general.moduleSettings.pronostics,
    ];
    const elementToDuplicate = pronostics[index];

    const newIndex = pronostics.length + 1;

    if (elementToDuplicate.type === "slideshow") {
      const duplicated: SlideShowElement = {
        ...elementToDuplicate,
        index: newIndex,
        title: `${elementToDuplicate.title} (Copy)`,
        player: elementToDuplicate.player.map((p: Player) => ({ ...p })), // Deep copy players
      };
      pronostics.push(duplicated);
    } else {
      const duplicated: PronosticV2Element = {
        ...elementToDuplicate,
        index: newIndex,
        element1Title: `${elementToDuplicate.element1Title} (Copy)`,
      };
      pronostics.push(duplicated);
    }

    form.setFieldValue(
      "commonSettings.general.moduleSettings.pronostics",
      pronostics
    );
  };

  // Handler for removing a pronostic element
  const handleRemovePronosticElement = (indexToRemove: number) => {
    const updated = form.values.commonSettings.general.moduleSettings.pronostics
      .filter((_, i) => i !== indexToRemove)
      .map((el, i) => ({ ...el, index: i + 1 }));

    form.setFieldValue(
      "commonSettings.general.moduleSettings.pronostics",
      updated
    );
  };

  const save = async () => {
    setIsLoading(true);

    // Validate slideshow workforce selection
    const slideshowErrors = validateSlideshowWorkforce();
    if (slideshowErrors.length > 0) {
      setIsLoading(false);
      const errorMessage = `Please select a players list for the following slideshow pronostics: ${slideshowErrors.map((e) => `#${e.index} (${e.title})`).join(", ")}`;
      console.error({
        title: "Validation Error",
        message: errorMessage,
        color: "red",
      });
      setComputeError(errorMessage);
      return;
    }

    const result = form.validate();
    const hasDateErrors =
      form.errors["specificSettings.beginAt"] ||
      form.errors["specificSettings.endAt"];

    if (!result.hasErrors && !hasDateErrors) {
      setIsLoading(true);
      // console.log(
      //   "Saving pronostic with values:",
      //   JSON.stringify(form.values, null, 2)
      // );

      try {
        if (pronostic && editMode && !isDuplicate) {
          await updatePronostic({ id: pronostic.id, ...form.values });
          setComputeError("");
        } else {
          await addPronostic(form.values).unwrap();
          navigate(`/admin/pronosticsv2`);
        }
        // navigate(`/admin/pronosticsv2`);
      } catch (error) {
        log("Error saving pronostic", error);
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      log("Validation failed", result.errors);
      if (hasDateErrors) {
        console.error({
          title: "Validation Error",
          message: "Please fix date/time validation errors before saving",
          color: "red",
        });
      }
    }
  };

  const saveWithResultsValidation = async () => {
    const pronostics =
      form.values.commonSettings.general.moduleSettings.pronostics;
    const results = form.values.specificSettings.pronosticResults;

    // Validate that all pronostics have results when button is clicked
    const missingResults = pronostics.filter((pronostic) => {
      const result = results.find((r) => r.pronosticIndex === pronostic.index);

      // Check if field1 is filled (allowing 0 and non-empty strings)
      const isField1Filled =
        result &&
        result.field1 !== undefined &&
        result.field1 !== null &&
        result.field1 !== "";

      // Check if field2 needs to be filled (only if element5FieldSize exists and is > 0)
      // Only check for input-like elements, skip slideshow elements
      const needsField2 =
        isInputLikeElement(pronostic) &&
        pronostic.element5FieldSize &&
        pronostic.element5FieldSize > 0;
      const isField2Filled =
        !needsField2 ||
        (result && result.field2 !== undefined && result.field2 !== null);

      return !isField1Filled || !isField2Filled;
    });

    if (missingResults.length > 0) {
      const missingDetails = missingResults.map((p) => {
        const result = results.find((r) => r.pronosticIndex === p.index);
        const issues = [];

        // Check field1 based on type
        if (p.type === "slideshow") {
          if (
            !result ||
            result.field1 === undefined ||
            result.field1 === null ||
            result.field1 === ""
          ) {
            issues.push("field1 (player name)");
          }
        } else {
          // Input/number type
          if (
            !result ||
            result.field1 === undefined ||
            result.field1 === null ||
            result.field1 === ""
          ) {
            issues.push("field1 (number)");
          }
        }

        if (
          isInputLikeElement(p) &&
          p.element5FieldSize &&
          p.element5FieldSize > 0 &&
          (!result || result.field2 === undefined || result.field2 === null)
        ) {
          issues.push("field2 (number)");
        }

        return `Prono#${p.index} (${issues.join(", ")})`;
      });

      console.error({
        title: "Validation Error",
        message: `Please fill all required result fields before saving. Missing: ${missingDetails.join("; ")}`,
        color: "red",
      });
      setComputeError(
        `Please fill all required result fields before saving. Missing: ${missingDetails.join("; ")}`
      );
      return;
    }

    // If all results are filled, proceed with the normal save
    await save();
  };

  const handleStatusChange = async (newStatus: any) => {
    if (!pronostic?.id) return;

    try {
      await updatePronostic({
        ...pronostic,
        status: newStatus,
      }).unwrap();

      form.setFieldValue("status", newStatus);
      console.log({
        title: "Status updated",
        message: `Status changed to "${newStatus}"`,
        color: "green",
      });
    } catch (err) {
      console.error({
        title: "Error",
        message: "Failed to update status",
        color: "red",
      });
    }
  };

  // const handleResultPublication = async (shouldPublish: boolean) => {
  //   if (!pronostic?.id) return;

  //   try {
  //     setIsButtonLoading(true);
  //     await updatePronostic({
  //       ...pronostic,
  //       specificSettings: {
  //         ...pronostic.specificSettings,
  //         resultsPublication: shouldPublish,
  //       },
  //     }).unwrap();

  //     form.setFieldValue("specificSettings.resultsPublication", shouldPublish);
  //     console.log({
  //       title: "Results publication updated",
  //       message: `Results publication set to "${shouldPublish}"`,
  //       color: "green",
  //     });
  //     setIsButtonLoading(false);
  //   } catch (err) {
  //     console.log({
  //       title: "Error",
  //       message: "Failed to update results publication status",
  //       color: "red",
  //     });
  //   }
  // };

  const handleAddWinCondition = () => {
    const current =
      form.values.commonSettings.general.moduleSettings.winCondition.content;
    const newCondition = {
      winConditionIndex: current.length + 1,
      pronosticIndex: 1, // Default to first pronostic
      type: "exact" as "exact" | "closest",
    };
    form.setFieldValue(
      "commonSettings.general.moduleSettings.winCondition.content",
      [...current, newCondition]
    );
  };

  const handleRemoveWinCondition = (index: number) => {
    const updated =
      form.values.commonSettings.general.moduleSettings.winCondition.content
        .filter((_, i) => i !== index)
        .map((el, i) => ({ ...el, winConditionIndex: i + 1 }));

    form.setFieldValue(
      "commonSettings.general.moduleSettings.winCondition.content",
      updated
    );
  };

  const moveCondition = (fromIndex: number, toIndex: number) => {
    const items = [
      ...form.values.commonSettings.general.moduleSettings.winCondition.content,
    ];
    const [movedItem] = items.splice(fromIndex, 1);
    items.splice(toIndex, 0, movedItem);

    // Update winConditionIndex based on new order
    const updatedItems = items.map((item, index) => ({
      ...item,
      winConditionIndex: index + 1,
    }));

    form.setFieldValue(
      "commonSettings.general.moduleSettings.winCondition.content",
      updatedItems
    );
  };
  // console.log(
  //   "pronostic results",
  //   pronostic?.specificSettings.pronosticResults,
  // );

  type SubPlaceWithWinnerInfo = {
    title: string;
    winnerInfo: string;
    id: any;
  };

  function getSubPlacesWithWinners(
    subPlaces: SubPlace[],
    winnersInfo: PronosticV2Winner[]
  ): SubPlaceWithWinnerInfo[] {
    // console.log("winnersInfo", winnersInfo);
    return subPlaces.map((sp) => {
      const matchingWinners = winnersInfo.filter(
        (w) => w.subPlaceIndex === sp.id.toString()
      );

      let winnerInfo: string;

      if (
        matchingWinners.length === 0 ||
        matchingWinners[0]?.winner.length > sp?.numberOfWinners
      ) {
        winnerInfo = "Ex aequo";
      } else {
        winnerInfo = matchingWinners
          .flatMap((winner) =>
            winner.winner.map((w) => {
              const {
                rank,
                name,
                totalScore,
                room,
                enterprise,
                predictionString,
              } = w;
              const roomPart = room && room.trim() !== "" ? `${room}` : "";
              const enterprisePart =
                enterprise && enterprise.trim() !== "" ? `${enterprise}` : "";
              const toShowTotalScore =
                pronostic?.commonSettings.general.moduleSettings.winCondition
                  .type === "PointsCalculation" && totalScore;
              // return `#${rank} - ${name} (${enterprisePart}${roomPart}${
              //   toShowTotalScore ? `, ${totalScore}pts` : ""
              // })`;
              void toShowTotalScore;
              const toShowPredictionString = !!predictionString;
              return `#${rank} - ${name} (${enterprisePart}, ${roomPart}, ${toShowPredictionString ? `<strong>${predictionString}</strong>` : ""})<br>`;
            })
          )
          .join("\n");
      }

      return {
        title: sp.title,
        id: sp.id,
        winnerInfo,
      };
    });
  }

  const handleDeletePronostic = async (id: string) => {
    try {
      await deletePronosticV2(id).unwrap();
      console.log(`Pronostic ${id} deleted successfully`);
      setOpened4(false);
      navigate("/admin/pronosticsv2");
    } catch (error) {
      console.error("Failed to delete Pronostic", error);
    }
  };
  const handleCheckWinner = async () => {
    if (
      pronostic?.specificSettings?.pronosticResults?.length! <
      pronostic?.commonSettings?.general?.moduleSettings?.pronostics?.length!
    ) {
      setComputeError("Please fill all results before to cumpute");
      return;
    }
    setIsButtonLoading(true);
    try {
      setComputeError("");
      const service = new PronosticV2Service();
      const res = await service.checkPronosticV2Winner({
        pronosticV2Id: pronostic!.id,
      });
      console.log(res);

      // no need to show result
      navigate(0); // with useNavigate() from react-router-dom v6+
    } catch (error) {
      console.error("Error checking winner:", error);
    } finally {
      setIsButtonLoading(false);
    }
  };

  //console.log("isLoading", isLoading);

  // Update the handleAddPointsCalc function
  const handleAddPointsCalc = () => {
    const current =
      form.values.commonSettings.general.moduleSettings.winCondition
        .pointsCalc || [];

    let newPointsCalc: WinConditionPointsCalcConfig;

    if (newPointsCalcType === "FourWeights") {
      newPointsCalc = {
        winConditionPointsCalcIndex: current.length + 1,
        type: "FourWeights",
        fourWeights: {
          correctResult: 0,
          aExact: 0,
          bExact: 0,
          exactMatch: 0,
        },
      };
    } else if (newPointsCalcType === "DistanceCalculation") {
      newPointsCalc = {
        winConditionPointsCalcIndex: current.length + 1,
        type: "DistanceCalculation",
        distanceCalc: {
          type: "ValueDistance",
          weightsDefinedPoints: { definiedPoints: 0 },
        },
      };
    } else {
      // ExactMatch case
      newPointsCalc = {
        winConditionPointsCalcIndex: current.length + 1,
        type: "ExactMatch",
        exactMatchCalc: {
          exactMatchPoints: 0,
        },
      };
    }

    form.setFieldValue(
      "commonSettings.general.moduleSettings.winCondition.pointsCalc",
      [...current, newPointsCalc]
    );
  };

  // Add this duplicate function
  const handleDuplicatePointsCalc = (indexToDuplicate: number) => {
    const current =
      form.values.commonSettings.general.moduleSettings.winCondition
        .pointsCalc || [];
    const elementToDuplicate = current[indexToDuplicate];

    const duplicated = {
      ...elementToDuplicate,
      winConditionPointsCalcIndex: current.length + 1,
    };

    const newElements = [...current, duplicated];

    // Re-index all elements
    const reIndexed = newElements.map((el, i) => ({
      ...el,
      winConditionPointsCalcIndex: i + 1,
    }));
    form.setFieldValue(
      "commonSettings.general.moduleSettings.winCondition.pointsCalc",
      reIndexed
    );
  };

  const handleRemovePointsCalc = (index: number) => {
    const current =
      form.values.commonSettings.general.moduleSettings.winCondition
        .pointsCalc || [];
    const updated = current
      .filter((_, i) => i !== index)
      .map((el, i) => ({ ...el, winConditionPointsCalcIndex: i + 1 }));

    form.setFieldValue(
      "commonSettings.general.moduleSettings.winCondition.pointsCalc",
      updated.length > 0 ? updated : undefined
    );
  };

  // Helper function to validate slideshow elements have workforce selected
  const validateSlideshowWorkforce = () => {
    const pronostics =
      form.values.commonSettings.general.moduleSettings.pronostics;
    const slideshowErrors: { index: number; title: string }[] = [];

    pronostics.forEach((element, index) => {
      if (element.type === "slideshow") {
        const slideshowElement = element as SlideShowElement;
        if (
          !slideshowElement.workforceId ||
          slideshowElement.workforceId.trim() === ""
        ) {
          slideshowErrors.push({
            index: element.index,
            title: slideshowElement.title || `SlideShow #${element.index}`,
          });
        }
      }
    });

    return slideshowErrors;
  };

  // Helper to check if a specific slideshow element has workforce error
  const getSlideshowWorkforceError = (elementIndex: number): string | null => {
    const element =
      form.values.commonSettings.general.moduleSettings.pronostics.find(
        (el) => el.index === elementIndex
      );
    if (element?.type === "slideshow") {
      const slideshowElement = element as SlideShowElement;
      if (
        !slideshowElement.workforceId ||
        slideshowElement.workforceId.trim() === ""
      ) {
        return "Please select a players list for this slideshow pronostic";
      }
    }
    return null;
  };

  return (
    <>
      {isLoading && <LoadingOverlay visible={true} overlayOpacity={0.8} />}
      <PronosticV2FormProvider form={form}>
        <Stack>
          <div
            className="sticky top-0 z-50 pb-4"
            style={{ backgroundColor: "#E9ECEF" }}
          >
            <Title order={3} align="center" m="xs">
              {isDuplicate
                ? `Duplicating ${pronostic?.name}`
                : pronostic?.name || "New Pronostic"}
            </Title>
            <Breadcrumbs separator="→">
              <Anchor component={Link} to={`/${ADMIN_PATH}`}>
                Admin
              </Anchor>
              <Anchor component={Link} to={`/${ADMIN_PATH}/pronosticsv2`}>
                Pronostics
              </Anchor>
            </Breadcrumbs>
            <Group position="right">
              <Button
                disabled={!isDirty && !isDuplicate}
                onClick={save}
                className="bg-button-admin disabled:opacity-75"
              >
                Save
              </Button>
            </Group>
          </div>
          <Group className="grid grid-cols-2">
            {organization === ADMIN_ORGANIZATION && (
              <AccessRights
                authorizedOrganizations={
                  PRONOSTICSV2_ORGANIZATION_VISIBILITY_AUTHORISED_ORGANIZATIONS
                }
                authorizedRoles={
                  PRONOSTICSV2_ORGANIZATION_VISIBILITY_AUTHORISED_ROLES
                }
              >
                <Select
                  sx={{ flex: 1 }}
                  label="Organisation"
                  required
                  data={ORGANIZATIONS}
                  {...form.getInputProps("owner.L1")}
                />
              </AccessRights>
            )}
          </Group>
          <Group className="grid grid-cols-2">
            <TextInput label="Title" required {...form.getInputProps("name")} />
          </Group>
          <Group className="grid grid-cols-2 ">
            <div className="flex gap-4 items-center w-full ">
              <div className="w-full">
                <Select
                  label="Status"
                  placeholder="Pick status"
                  data={[
                    { value: "not started", label: "Not Started" },
                    { value: "ongoing", label: "Started" },
                    { value: "published", label: "Published" },
                    { value: "closed", label: "Ended" },
                    { value: "archived", label: "Archived" },
                  ]}
                  {...form.getInputProps("status")}
                />
              </div>
              {form.values?.status === "not started" && (
                <div className="h-[25px] w-[25px] rounded-full border border-dashed border-black mt-6" />
              )}
              {pronostic?.status === "ongoing" && !isDuplicate && (
                <div className="h-[25px] w-[25px] rounded-full bg-green-500 mt-6" />
              )}
              {pronostic?.status === "published" && (
                <div className="h-[25px] w-[25px] rounded-full bg-green-700 mt-6" />
              )}
              {pronostic?.status === "closed" && (
                <div className="h-[25px] w-[25px] rounded-full bg-red-500 mt-6" />
              )}
              {pronostic?.status === "archived" && (
                <div className="h-[25px] w-[25px] rounded-full bg-gray-500 mt-6" />
              )}
            </div>
            <Group position="right">
              {pronostic?.status === "not started" && !isDuplicate && (
                <Button
                  className="bg-green-500 w-auto "
                  onClick={() => {
                    handleStatusChange("ongoing");
                  }}
                >
                  Launch
                </Button>
              )}
              {pronostic?.status === "ongoing" && !isDuplicate && (
                <Button
                  className="bg-green-700 w-auto "
                  onClick={() => {
                    handleStatusChange("published");
                  }}
                  loading={isButtonLoading}
                >
                  Publish
                </Button>
              )}
              {pronostic?.status === "published" && !isDuplicate && (
                <Button
                  className="bg-red-500 w-auto "
                  onClick={() => {
                    handleStatusChange("closed");
                  }}
                >
                  Stop
                </Button>
              )}
              {pronostic?.status === "closed" && !isDuplicate && (
                <Button
                  className="bg-gray-500 w-auto "
                  onClick={() => {
                    handleStatusChange("archived");
                  }}
                >
                  Archive
                </Button>
              )}
              {pronostic?.status === "archived" && !isDuplicate && (
                <Button
                  className="bg-red-500 w-auto "
                  onClick={() => {
                    handleStatusChange("closed");
                  }}
                >
                  Reactivate
                </Button>
              )}
            </Group>
          </Group>
          <Collapsable title="Results">
            <Group position="right">
              {/* <div className="text-red-600">{computeError}</div> */}
              <Button
                onClick={() => {
                  handleCheckWinner();
                }}
                loading={isButtonLoading}
                className="bg-button-admin disabled:opacity-75"
                size="xs"
              >
                Compute
              </Button>
            </Group>
            <GenericTable
              headers={[
                { key: "title", label: "Place", sortable: true },
                { key: "winnerInfo", label: "Winner info", sortable: true },
              ]}
              data={getSubPlacesWithWinners(
                form.values?.commonSettings?.general?.moduleSettings?.place
                  ?.subPlaces || [],
                pronostic?.specificSettings?.winnersInfo || []
              )}
              onRowClick={(row) => {
                setSubPlaceTitle(row.title);
                setSubPlaceId(row.id);
                setOpened1(true);
              }}
            />
            <Group position="right">
              {" "}
              {pronostic?.id && (
                <PlayerQueryBySubPlaces pronosticV2={pronostic} />
              )}
            </Group>
          </Collapsable>
          <Collapsable title="Pronostic Settings">
            <Group className="grid grid-cols-2">
              <DatePicker
                label="Start Date"
                value={new Date(form.values.specificSettings.beginAt)}
                onChange={(date) => {
                  if (date) {
                    form.setFieldValue(
                      "specificSettings.beginAt",
                      date.toISOString()
                    );

                    // Simple validation: check if start is before end
                    const endDate = new Date(
                      form.values.specificSettings.endAt
                    );
                    if (date >= endDate) {
                      form.setFieldError(
                        "specificSettings.beginAt",
                        "Start date must be before end date"
                      );
                    } else {
                      form.clearFieldError("specificSettings.beginAt");
                      form.clearFieldError("specificSettings.endAt");
                    }
                  }
                }}
                error={form.errors["specificSettings.beginAt"]}
              />

              <TimeInput
                label="Time"
                className="w-[30%]"
                value={new Date(form.values.specificSettings.beginAt)}
                onChange={(date) => {
                  if (date) {
                    const currentDate = new Date(
                      form.values.specificSettings.beginAt
                    );
                    currentDate.setHours(date.getHours());
                    currentDate.setMinutes(date.getMinutes());

                    form.setFieldValue(
                      "specificSettings.beginAt",
                      currentDate.toISOString()
                    );

                    // Simple validation: check if start is before end
                    const endDate = new Date(
                      form.values.specificSettings.endAt
                    );
                    if (currentDate >= endDate) {
                      form.setFieldError(
                        "specificSettings.beginAt",
                        "Start time must be before end time"
                      );
                    } else {
                      form.clearFieldError("specificSettings.beginAt");
                      form.clearFieldError("specificSettings.endAt");
                    }
                  }
                }}
                error={form.errors["specificSettings.beginAt"]}
              />

              <DatePicker
                label="End Date"
                value={new Date(form.values.specificSettings.endAt)}
                onChange={(date) => {
                  if (date) {
                    form.setFieldValue(
                      "specificSettings.endAt",
                      date.toISOString()
                    );

                    // Simple validation: check if end is after start
                    const startDate = new Date(
                      form.values.specificSettings.beginAt
                    );
                    if (date <= startDate) {
                      form.setFieldError(
                        "specificSettings.endAt",
                        "End date must be after start date"
                      );
                    } else {
                      form.clearFieldError("specificSettings.beginAt");
                      form.clearFieldError("specificSettings.endAt");
                    }
                  }
                }}
                error={form.errors["specificSettings.endAt"]}
              />

              <TimeInput
                label="Time"
                className="w-[30%]"
                value={new Date(form.values.specificSettings.endAt)}
                onChange={(date) => {
                  if (date) {
                    const currentDate = new Date(
                      form.values.specificSettings.endAt
                    );
                    currentDate.setHours(date.getHours());
                    currentDate.setMinutes(date.getMinutes());

                    form.setFieldValue(
                      "specificSettings.endAt",
                      currentDate.toISOString()
                    );

                    // Simple validation: check if end is after start
                    const startDate = new Date(
                      form.values.specificSettings.beginAt
                    );
                    if (currentDate <= startDate) {
                      form.setFieldError(
                        "specificSettings.endAt",
                        "End time must be after start time"
                      );
                    } else {
                      form.clearFieldError("specificSettings.beginAt");
                      form.clearFieldError("specificSettings.endAt");
                    }
                  }
                }}
                error={form.errors["specificSettings.endAt"]}
              />
            </Group>

            <Group mt="xs" classNames="w-[15%]">
              {pronostic?.commonSettings.general.moduleSettings.pronostics.map(
                (element) => {
                  // Find or create result for this index
                  const result =
                    form.values.specificSettings.pronosticResults.find(
                      (r) => r.pronosticIndex === element.index
                    ) || {
                      pronosticIndex: element.index,
                      field1: undefined,
                      field2: null,
                    };

                  return (
                    <div key={element.index}>
                      <Text weight={500}>
                        #{element.index} -{" "}
                        {isInputLikeElement(element)
                          ? element.element1Title
                          : (element as SlideShowElement).title}
                      </Text>
                      <Group className="grid grid-cols-2 w-[40%]">
                        {element.type === "slideshow" ? (
                          <Select
                            placeholder="Select player"
                            value={String(result.field1)}
                            className="w-[190px]"
                            onChange={(value) => {
                              const updated = JSON.parse(
                                JSON.stringify(
                                  form.values.specificSettings.pronosticResults
                                )
                              );
                              const existingIndex = updated.findIndex(
                                (r: PronosticV2Results) =>
                                  r.pronosticIndex === element.index
                              );

                              if (existingIndex >= 0) {
                                updated[existingIndex] = {
                                  ...updated[existingIndex],
                                  field1: value || "",
                                };
                              } else {
                                updated.push({
                                  pronosticIndex: element.index,
                                  field1: value || "",
                                  field2: null,
                                });
                              }

                              form.setFieldValue(
                                "specificSettings.pronosticResults",
                                updated
                              );
                            }}
                            data={
                              element.type === "slideshow"
                                ? (element as SlideShowElement).player.map(
                                    (player) => ({
                                      value: player.name,
                                      label: player.name,
                                    })
                                  )
                                : []
                            }
                            searchable
                            nothingFound="No players found"
                            disabled={
                              element.type !== "slideshow" ||
                              (element as SlideShowElement).player.length === 0
                            }
                          />
                        ) : (
                          <NumberInput
                            value={
                              result.field1 === undefined ||
                              result.field1 === null
                                ? undefined
                                : Number(result.field1)
                            }
                            onChange={(value) => {
                              const updated = JSON.parse(
                                JSON.stringify(
                                  form.values.specificSettings.pronosticResults
                                )
                              );
                              const existingIndex = updated.findIndex(
                                (r: PronosticV2Results) =>
                                  r.pronosticIndex === element.index
                              );

                              if (existingIndex >= 0) {
                                updated[existingIndex] = {
                                  ...updated[existingIndex],
                                  field1: value === undefined ? "" : value, // Allow 0, set undefined to empty string for number input
                                };
                              } else {
                                updated.push({
                                  pronosticIndex: element.index,
                                  field1: value === undefined ? "" : value,
                                  field2: null,
                                });
                              }

                              form.setFieldValue(
                                "specificSettings.pronosticResults",
                                updated
                              );
                            }}
                            hideControls
                            // Allowing 0 is default for NumberInput, no special prop needed
                          />
                        )}

                        {isInputLikeElement(element) &&
                          element.element5FieldSize && (
                            <NumberInput
                              value={
                                result.field2 === null ||
                                result.field2 === undefined
                                  ? undefined
                                  : result.field2
                              }
                              hideControls
                              onChange={(value) => {
                                const updated = JSON.parse(
                                  JSON.stringify(
                                    form.values.specificSettings
                                      .pronosticResults
                                  )
                                );
                                const existingIndex = updated.findIndex(
                                  (r: PronosticV2Results) =>
                                    r.pronosticIndex === element.index
                                );

                                if (existingIndex >= 0) {
                                  updated[existingIndex] = {
                                    ...updated[existingIndex],
                                    field2: value === undefined ? null : value, // Keep 0 as 0, set undefined to null
                                  };
                                } else {
                                  updated.push({
                                    pronosticIndex: element.index,
                                    field1: "",
                                    field2: value === undefined ? null : value, // Keep 0 as 0, set undefined to null
                                  });
                                }

                                form.setFieldValue(
                                  "specificSettings.pronosticResults",
                                  updated
                                );
                              }}
                            />
                          )}
                      </Group>
                    </div>
                  );
                }
              )}
            </Group>
            <Button
              disabled={!isDirty && !isDuplicate}
              onClick={saveWithResultsValidation}
              className="bg-green-600 mt-4 disabled:opacity-75"
            >
              Save Results
            </Button>
          </Collapsable>
          <Collapsable title="Web App Settings" defaultOpened={false}>
            <Stack>
              <Stack>
                <Textarea
                  label="Welcome Message"
                  {...form.getInputProps(
                    "commonSettings.webApp.texts.welcomeMessage"
                  )}
                />
                <Textarea
                  label="Footer Message"
                  {...form.getInputProps(
                    "commonSettings.webApp.texts.footerMessage"
                  )}
                />
                <Textarea
                  label="Thank You Message"
                  {...form.getInputProps(
                    "commonSettings.webApp.texts.thankYouMessage"
                  )}
                />
                <Textarea
                  label="No Result Message"
                  {...form.getInputProps(
                    "commonSettings.webApp.texts.noResultMessage"
                  )}
                />
                <Textarea
                  label="Not Started Message"
                  {...form.getInputProps(
                    "commonSettings.webApp.texts.notStartedMessage"
                  )}
                />
                <Textarea
                  label="Too Late Message"
                  {...form.getInputProps(
                    "commonSettings.webApp.texts.tooLateMessage"
                  )}
                />
                <Textarea
                  label="Mandatory Message"
                  {...form.getInputProps(
                    "commonSettings.webApp.texts.mandatoryMessage"
                  )}
                />

                <Group className="grid grid-cols-2">
                  <TextInput
                    label="Submit Button Label"
                    {...form.getInputProps(
                      "commonSettings.webApp.texts.submitButtonLabel"
                    )}
                  />
                  <div />
                  <TextInput
                    label="Back Home Button Label"
                    {...form.getInputProps(
                      "commonSettings.webApp.texts.backHomeButtonLabel"
                    )}
                  />
                  <div />

                  <TextInput
                    label="Results Button Label"
                    {...form.getInputProps(
                      "commonSettings.webApp.texts.resultsButtonLabel"
                    )}
                  />
                  <div />
                  <TextInput
                    label="Refresh Button Label"
                    {...form.getInputProps(
                      "commonSettings.webApp.texts.refreshButtonLabel"
                    )}
                  />
                  <div />
                  <TextInput
                    label="Ranking Page Title"
                    {...form.getInputProps(
                      "commonSettings.webApp.texts.rankingPageTitle"
                    )}
                  />
                  <div />
                  <TextInput
                    label="Subplace Prefix Title"
                    {...form.getInputProps(
                      "commonSettings.webApp.texts.subPlacePrefixTitle"
                    )}
                  />
                </Group>
              </Stack>
              <Divider mt={"xl"} mb="md" />

              <FileInput
                label="Background Image URL"
                {...form.getInputProps(
                  "commonSettings.webApp.medias.backGroundImage"
                )}
              />
              <Group className="grid grid-cols-2">
                <Select
                  label="Background Position"
                  placeholder="Select background position"
                  data={[
                    // { value: "inherit", label: "inherit" },
                    // { value: "initial", label: "initial" },
                    // { value: "center", label: "center" },
                    // { value: "right", label: "right" },
                    // { value: "left", label: "left" },
                    // { value: "bottom", label: "bottom" },
                    // { value: "top", label: "top" },
                    {
                      value: "center bottom",
                      label: "horizontal: center, vertical: bottom",
                    },
                    {
                      value: "center center",
                      label: "horizontal: center, vertical: center",
                    },
                    {
                      value: "center top",
                      label: "horizontal: center, vertical: top",
                    },
                    {
                      value: "right bottom",
                      label: "horizontal: right, vertical: bottom",
                    },
                    {
                      value: "right center",
                      label: "horizontal: right, vertical: center",
                    },
                    {
                      value: "right top",
                      label: "horizontal: right, vertical: top",
                    },
                    {
                      value: "left bottom",
                      label: "horizontal: left, vertical: bottom",
                    },
                    {
                      value: "left center",
                      label: "horizontal: left, vertical: center",
                    },
                    {
                      value: "left top",
                      label: "horizontal: left, vertical: top",
                    },
                  ]}
                  {...form.getInputProps(
                    "commonSettings.webApp.moduleSettings.backGroundPosition"
                  )}
                />
              </Group>

              <Divider mt={"xl"} mb="md" />
              <Group mt={"xl"} className="grid grid-cols-2 w-[70%]">
                <ColorInput
                  label="Message Color"
                  {...form.getInputProps(
                    "commonSettings.webApp.moduleSettings.messageTitleColor"
                  )}
                />
                <TextInput
                  label="Message Size"
                  className="w-[50%]"
                  {...form.getInputProps(
                    "commonSettings.webApp.moduleSettings.messageTitleSize"
                  )}
                />
                <ColorInput
                  label="Pronostic Title Color"
                  {...form.getInputProps(
                    "commonSettings.webApp.moduleSettings.pronoTitleColor"
                  )}
                />
                <TextInput
                  label="Pronostic Title Size"
                  className="w-[50%]"
                  {...form.getInputProps(
                    "commonSettings.webApp.moduleSettings.pronoTitleSize"
                  )}
                />
                <ColorInput
                  label="Button Background Color"
                  {...form.getInputProps(
                    "commonSettings.webApp.moduleSettings.buttonBgColor"
                  )}
                />
                <ColorInput
                  label="Button Text Color"
                  {...form.getInputProps(
                    "commonSettings.webApp.moduleSettings.buttonTextColor"
                  )}
                />
                <ColorInput
                  label="Mandatory Text Color"
                  {...form.getInputProps(
                    "commonSettings.webApp.moduleSettings.mandatoryTextColor"
                  )}
                />
                <TextInput
                  label="Mandatory Text Size"
                  className="w-[50%]"
                  {...form.getInputProps(
                    "commonSettings.webApp.moduleSettings.mandatoryTextSize"
                  )}
                />
                <ColorInput
                  label="Ranking Title Color"
                  {...form.getInputProps(
                    "commonSettings.webApp.moduleSettings.rankingPageTitleColor"
                  )}
                />
                <TextInput
                  label="Ranking Title Size"
                  className="w-[50%]"
                  {...form.getInputProps(
                    "commonSettings.webApp.moduleSettings.rankingPageTitleSize"
                  )}
                />
                <ColorInput
                  label="Ranking Page Border Color"
                  {...form.getInputProps(
                    "commonSettings.webApp.moduleSettings.rankingPageBorderColor"
                  )}
                />
              </Group>
            </Stack>
          </Collapsable>
          <Collapsable title="Header" defaultOpened={false}>
            <Switch
              className="pb-3"
              checked={form.values.header?.enabled}
              label="Enable Header"
              onLabel="Yes"
              offLabel="No"
              onChange={(event) => {
                const value = event.currentTarget.checked;
                form.setFieldValue("header.enabled", value);
              }}
              {...form.getInputProps("header.enabled")}
            />
            <Textarea
              className="pb-3"
              minRows={15}
              label="Header HTML"
              {...form.getInputProps("header.html")}
            />
          </Collapsable>
          <Collapsable title="Public Sharing Settings" defaultOpened={false}>
            <Stack>
              <Textarea
                label="Introduction Message"
                {...form.getInputProps(
                  "commonSettings.publicSharing.texts.introductionMessage"
                )}
              />
              <Divider my={"md"} />

              <FileInput
                label="Background Image URL"
                {...form.getInputProps(
                  "commonSettings.publicSharing.medias.backgroundImage"
                )}
              />
              <FileInput
                label="Sponsor Image URL"
                {...form.getInputProps(
                  "commonSettings.publicSharing.medias.sponsorImage"
                )}
              />
              <Divider my={"md"} />
              <Group className="grid grid-cols-2 w-[60%]">
                <ColorInput
                  label="Messages Color"
                  {...form.getInputProps(
                    "commonSettings.publicSharing.moduleSettings.messagesColor"
                  )}
                />
                <TextInput
                  label="Messages Size"
                  className="w-[50%]"
                  {...form.getInputProps(
                    "commonSettings.publicSharing.moduleSettings.messagesSize"
                  )}
                />
                <TextInput
                  label="Screen Top Margin"
                  className="w-[50%]"
                  {...form.getInputProps(
                    "commonSettings.publicSharing.moduleSettings.screenTopMargin"
                  )}
                />
                <TextInput
                  label="Screen Left Margin"
                  className="w-[50%]"
                  {...form.getInputProps(
                    "commonSettings.publicSharing.moduleSettings.screenLeftMargin"
                  )}
                />
              </Group>
            </Stack>
          </Collapsable>
          <Collapsable title="Edition">
            <div>
              <Group className="grid grid-cols-2">
                <Select
                  label="Place instance"
                  placeholder="Choose a place"
                  data={places.map((place) => ({
                    value: place.id,
                    label: place.name,
                  }))}
                  value={
                    form.values.commonSettings.general.moduleSettings.place
                      .placeId
                  }
                  onChange={(value) => {
                    const selected = places.find((p) => p.id === value);
                    form.setFieldValue(
                      "commonSettings.general.moduleSettings.place",
                      {
                        placeId: selected?.id || "",
                        placeTitle: selected?.name || "",
                        subPlaces: selected?.detailedSettings.subPlaces || [],
                      }
                    );
                  }}
                  searchable
                  nothingFound="No places found"
                  disabled={loadingPlaces}
                />
                <ActionIcon
                  onClick={() => {
                    setOpened(true);
                  }}
                >
                  <Edit size={20} color="blue" />
                </ActionIcon>
              </Group>

              {form.values.commonSettings.general.moduleSettings.pronostics.map(
                (element, index) => (
                  <div key={index}>
                    <div className="my-4 border border-gray-300 rounded p-4">
                      <Group position="apart" mb="md">
                        <Text weight={500}>
                          {`Prono#${element.index} - ${
                            element.type === "slideshow"
                              ? "SlideShow"
                              : element.type === "input"
                                ? "Input"
                                : "Default"
                          }`}
                        </Text>
                        <Group spacing="xs">
                          <ActionIcon
                            onClick={() =>
                              handleDuplicatePronosticElement(index)
                            }
                            disabled={
                              element.type === "slideshow"
                                ? !element.title
                                : !element.element1Title
                            }
                          >
                            <Copy size={20} color="blue" />
                          </ActionIcon>
                          <ActionIcon
                            onClick={() => handleRemovePronosticElement(index)}
                          >
                            <Trash color="red" size={20} />
                          </ActionIcon>
                        </Group>
                      </Group>

                      {element.type === "slideshow" ? (
                        // SlideShow type - using SlideShowElement interface
                        <Group className="grid grid-cols-1 gap-4">
                          {/* Title Section - Can be used independently */}
                          <TextInput
                            label="Title"
                            required
                            value={element.title || ""}
                            onChange={(event) => {
                              const updated = [
                                ...form.values.commonSettings.general
                                  .moduleSettings.pronostics,
                              ];
                              updated[index] = {
                                ...(updated[index] as SlideShowElement),
                                title: event.currentTarget.value,
                              };
                              form.setFieldValue(
                                "commonSettings.general.moduleSettings.pronostics",
                                updated
                              );
                            }}
                          />

                          {/* Workforce Section - Can be used independently */}
                          <Group className="grid grid-cols-2 gap-2">
                            <div className="col-span-1">
                              <Select
                                label="Players List"
                                placeholder="Choose a players list"
                                data={workforces.map((workforce) => ({
                                  value: workforce.id,
                                  label: workforce.name,
                                }))}
                                value={
                                  (element as SlideShowElement).workforceId ||
                                  ""
                                }
                                onChange={(selectedId) => {
                                  const selected = workforces.find(
                                    (w) => w.id === selectedId
                                  );
                                  if (selected) {
                                    const updatedPronostics = [
                                      ...form.values.commonSettings.general
                                        .moduleSettings.pronostics,
                                    ];
                                    updatedPronostics[index] = {
                                      ...(updatedPronostics[
                                        index
                                      ] as SlideShowElement),
                                      player: selected.players.map(
                                        (player) => ({
                                          name: player.name,
                                          logo: player.logo,
                                        })
                                      ),
                                      workforceId: selected.id, // Store the workforce ID
                                    };

                                    form.setFieldValue(
                                      "commonSettings.general.moduleSettings.pronostics",
                                      updatedPronostics
                                    );
                                  }
                                }}
                                searchable
                                nothingFound="No workforces found"
                                disabled={loadingWorkforces}
                              />
                              {getSlideshowWorkforceError(element.index) && (
                                <div className="text-red-600 text-sm mt-1">
                                  {getSlideshowWorkforceError(element.index)}
                                </div>
                              )}
                            </div>

                            {/* Edit Action Section */}
                            <ActionIcon
                              onClick={() => {
                                setEditingSlideshowIndex(index);
                                setOpened5(true);
                              }}
                            >
                              <Edit size={20} color="blue" />
                            </ActionIcon>
                          </Group>

                          {/* <Button
                            variant="light"
                            size="xs"
                            className="mt-2"
                            onClick={() => {
                              // Add player functionality here
                              const updated = [
                                ...form.values.commonSettings.general
                                  .moduleSettings.pronostics,
                              ];
                              const currentElement = updated[
                                index
                              ] as SlideShowElement;
                              currentElement.player = [
                                ...currentElement.player,
                                { name: "", logo: "" },
                              ];
                              form.setFieldValue(
                                "commonSettings.general.moduleSettings.pronostics",
                                updated
                              );
                            }}
                          >
                            Add Player
                          </Button> */}
                        </Group>
                      ) : (
                        // Input/Default type - using PronosticV2Element interface
                        <Group className="grid grid-cols-1 gap-4">
                          <TextInput
                            label="Title"
                            required
                            {...form.getInputProps(
                              `commonSettings.general.moduleSettings.pronostics.${index}.element1Title`
                            )}
                          />
                          <FileInput
                            label="Left Visual"
                            {...form.getInputProps(
                              `commonSettings.general.moduleSettings.pronostics.${index}.element2Visual`
                            )}
                          />
                          <Textarea
                            label="Left Title"
                            {...form.getInputProps(
                              `commonSettings.general.moduleSettings.pronostics.${index}.element3Title`
                            )}
                          />
                          <NumberInput
                            label="Left Field Size"
                            hideControls
                            className="w-[12%]"
                            min={0}
                            {...form.getInputProps(
                              `commonSettings.general.moduleSettings.pronostics.${index}.element4FieldSize`
                            )}
                          />
                          <NumberInput
                            label="Right Field Size"
                            hideControls
                            className="w-[12%]"
                            min={0}
                            {...form.getInputProps(
                              `commonSettings.general.moduleSettings.pronostics.${index}.element5FieldSize`
                            )}
                          />
                          <Textarea
                            label="Right Title"
                            required
                            {...form.getInputProps(
                              `commonSettings.general.moduleSettings.pronostics.${index}.element6Title`
                            )}
                          />
                          <FileInput
                            label="Right Visual"
                            {...form.getInputProps(
                              `commonSettings.general.moduleSettings.pronostics.${index}.element7Visual`
                            )}
                          />
                        </Group>
                      )}
                    </div>
                  </div>
                )
              )}
            </div>

            <Group position="center" align="center" className="gap-4">
              <Select
                label="New Pronostic Type"
                value={newPronosticType}
                onChange={(value) => {
                  if (value === "input" || value === "slideshow") {
                    setNewPronosticType(value);
                  }
                }}
                data={[
                  { value: "input", label: "Input" },
                  { value: "slideshow", label: "SlideShow" },
                ]}
                className="w-48"
              />
              <Button
                onClick={() => handleAddPronosticElement(newPronosticType)}
                variant="subtle"
                leftIcon={<CirclePlus />}
                className="mt-6"
              >
                Add Pronostic
              </Button>
            </Group>
          </Collapsable>
          <Collapsable title="Win Conditions" defaultOpened={false}>
            <Group position="apart" className="mb-2">
              <Select
                label="Type"
                data={["PointsCalculation", "OrderedAccuracy"]}
                {...form.getInputProps(
                  "commonSettings.general.moduleSettings.winCondition.type"
                )}
              />
            </Group>
            <div>
              {form.values.commonSettings.general.moduleSettings.winCondition
                .type === "OrderedAccuracy" && (
                <div>
                  <List
                    spacing="xs"
                    size="sm"
                    mt={"sm"}
                    center
                    sx={(theme) => ({
                      borderRadius: theme.radius.md,
                      // padding: theme.spacing.md,
                    })}
                  >
                    {form.values.commonSettings.general.moduleSettings.winCondition.content.map(
                      (condition, index) => (
                        <List.Item
                          key={condition.winConditionIndex}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "1rem",
                            padding: "1rem",
                            border: "1px solid",
                            borderColor: "#dee2e6",
                            borderRadius: "0.5rem",
                            marginBottom: "0.5rem",
                          }}
                          icon={
                            <ThemeIcon
                              color="gray"
                              size={24}
                              radius="xl"
                              sx={{ cursor: "grab" }}
                              onMouseDown={(e) => {
                                e.preventDefault();
                                // Implement drag logic if needed
                              }}
                            >
                              <GripVertical size={16} />
                            </ThemeIcon>
                          }
                        >
                          {/* <Group position="apart">
                      <Text>Condition #{condition.winConditionIndex}</Text>
                    </Group> */}
                          <Group className="grid grid-cols-3 w-full">
                            <Select
                              label="Pronostic"
                              data={form.values.commonSettings.general.moduleSettings.pronostics
                                .map((p, i) => ({
                                  value: i + 1, // Changed to number
                                  label: `#${i + 1} - ${isInputLikeElement(p) ? p.element1Title : (p as SlideShowElement).title}`,
                                }))
                                .filter(
                                  (option) =>
                                    !form.values.commonSettings.general.moduleSettings.winCondition.content.some(
                                      (c, i2) =>
                                        i2 !== index &&
                                        c.pronosticIndex === option.value // Changed comparison to number
                                    )
                                )}
                              {...form.getInputProps(
                                `commonSettings.general.moduleSettings.winCondition.content.${index}.pronosticIndex`
                              )}
                              onChange={(value) => {
                                const newPronosticIndex = Number(value);
                                const associatedProno =
                                  form.values.commonSettings.general.moduleSettings.pronostics.find(
                                    (p) => p.index === newPronosticIndex
                                  );

                                if (associatedProno?.type === "slideshow") {
                                  // If new pronostic is slideshow, force type to "exact"
                                  form.setFieldValue(
                                    `commonSettings.general.moduleSettings.winCondition.content.${index}.type`,
                                    "exact"
                                  );
                                }
                                form.setFieldValue(
                                  `commonSettings.general.moduleSettings.winCondition.content.${index}.pronosticIndex`,
                                  newPronosticIndex
                                );
                              }}
                            />

                            {(() => {
                              const associatedPronostic =
                                form.values.commonSettings.general.moduleSettings.pronostics.find(
                                  (p) => p.index === condition.pronosticIndex
                                );
                              const isSlideshowPronostic =
                                associatedPronostic?.type === "slideshow";
                              return (
                                <Select
                                  label="Type"
                                  data={
                                    isSlideshowPronostic
                                      ? [{ value: "exact", label: "Exact" }]
                                      : [
                                          { value: "exact", label: "Exact" },
                                          {
                                            value: "closest",
                                            label: "Closest",
                                          },
                                        ]
                                  }
                                  value={
                                    isSlideshowPronostic
                                      ? "exact"
                                      : form.values.commonSettings.general
                                          .moduleSettings.winCondition.content[
                                          index
                                        ].type
                                  }
                                  onChange={(value) => {
                                    if (
                                      !isSlideshowPronostic ||
                                      value === "exact"
                                    ) {
                                      form.setFieldValue(
                                        `commonSettings.general.moduleSettings.winCondition.content.${index}.type`,
                                        value
                                      );
                                    }
                                  }}
                                  disabled={isSlideshowPronostic}
                                />
                              );
                            })()}
                            <ActionIcon
                              onClick={() => handleRemoveWinCondition(index)}
                            >
                              <Trash color="red" size={20} />
                            </ActionIcon>
                          </Group>
                          {index > 0 && (
                            <Button
                              compact
                              variant="subtle"
                              onClick={() => moveCondition(index, index - 1)}
                            >
                              Move Up
                            </Button>
                          )}
                          {index <
                            form.values.commonSettings.general.moduleSettings
                              .winCondition.content.length -
                              1 && (
                            <Button
                              compact
                              variant="subtle"
                              onClick={() => moveCondition(index, index + 1)}
                            >
                              Move Down
                            </Button>
                          )}
                        </List.Item>
                      )
                    )}
                  </List>
                  <Group position="center" mt="md">
                    <Button
                      onClick={handleAddWinCondition}
                      variant="subtle"
                      leftIcon={<CirclePlus />}
                      disabled={
                        form.values.commonSettings.general.moduleSettings
                          .pronostics.length === 0 ||
                        form.values.commonSettings.general.moduleSettings
                          .winCondition.content.length >=
                          form.values.commonSettings.general.moduleSettings
                            .pronostics.length
                      }
                    >
                      Add Win Condition
                    </Button>
                  </Group>
                </div>
              )}
            </div>

            <div>
              {form.values.commonSettings.general.moduleSettings.winCondition
                .type === "PointsCalculation" && (
                <div>
                  <List
                    spacing="xs"
                    size="sm"
                    center
                    mt="sm"
                    sx={(theme) => ({
                      borderRadius: theme.radius.md,
                      // padding: theme.spacing.md,
                    })}
                  >
                    {form.values.commonSettings.general.moduleSettings.winCondition.pointsCalc?.map(
                      (pointsCalc, index) => (
                        <div
                          style={{
                            padding: "1rem",
                            border: "1px solid",
                            borderColor: "#dee2e6",
                            borderRadius: "0.5rem",
                            marginBottom: "0.5rem",
                          }}
                        >
                          <Group position="apart" className="mb-2">
                            <Select
                              label="Calculation Type"
                              data={[
                                {
                                  value: "FourWeights",
                                  label: "Four Fields Points",
                                },
                                {
                                  value: "DistanceCalculation",
                                  label: "Distance Calculation",
                                },
                                {
                                  value: "ExactMatch",
                                  label: "Exact Match",
                                },
                              ]}
                              value={pointsCalc.type}
                              onChange={(value) => {
                                if (
                                  value === "FourWeights" ||
                                  value === "DistanceCalculation" ||
                                  value === "ExactMatch"
                                ) {
                                  const updated = [
                                    ...(form.values.commonSettings.general
                                      .moduleSettings.winCondition.pointsCalc ||
                                      []),
                                  ];
                                  updated[index] = {
                                    ...updated[index],
                                    type: value,
                                    fourWeights:
                                      value === "FourWeights"
                                        ? {
                                            correctResult: 0,
                                            aExact: 0,
                                            bExact: 0,
                                            exactMatch: 0,
                                          }
                                        : undefined,
                                    distanceCalc:
                                      value === "DistanceCalculation"
                                        ? {
                                            type: "ValueDistance",
                                            weightsDefinedPoints: {
                                              definiedPoints: 0,
                                            },
                                          }
                                        : undefined,
                                    exactMatchCalc:
                                      value === "ExactMatch"
                                        ? {
                                            exactMatchPoints: 0,
                                          }
                                        : undefined,
                                  };
                                  form.setFieldValue(
                                    "commonSettings.general.moduleSettings.winCondition.pointsCalc",
                                    updated
                                  );
                                }
                              }}
                            />
                          </Group>

                          <List.Item
                            key={pointsCalc.winConditionPointsCalcIndex}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "1rem",
                            }}
                          >
                            {pointsCalc.type === "FourWeights" &&
                              pointsCalc.fourWeights && (
                                <div>
                                  <Group position="apart" className="w-full">
                                    <Text weight={500} className="text-xl">
                                      Points Calculation #
                                      {pointsCalc.winConditionPointsCalcIndex}
                                    </Text>
                                    <div></div>
                                    <Group spacing="xs">
                                      <ActionIcon
                                        onClick={() =>
                                          handleDuplicatePointsCalc(index)
                                        }
                                      >
                                        <Copy size={20} color="blue" />
                                      </ActionIcon>
                                      <ActionIcon
                                        onClick={() =>
                                          handleRemovePointsCalc(index)
                                        }
                                      >
                                        <Trash color="red" size={20} />
                                      </ActionIcon>
                                    </Group>
                                  </Group>
                                  <Group className="grid grid-cols-5 gap-28 w-full mt-2">
                                    <NumberInput
                                      label="Correct result"
                                      hideControls
                                      value={
                                        pointsCalc.fourWeights.correctResult
                                      }
                                      onChange={(value) => {
                                        const updated = [
                                          ...(form.values.commonSettings.general
                                            .moduleSettings.winCondition
                                            .pointsCalc || []),
                                        ];
                                        updated[index] = {
                                          ...updated[index],
                                          fourWeights: {
                                            ...updated[index].fourWeights!,
                                            correctResult: value || 0,
                                          },
                                        };
                                        form.setFieldValue(
                                          "commonSettings.general.moduleSettings.winCondition.pointsCalc",
                                          updated
                                        );
                                      }}
                                    />
                                    <NumberInput
                                      label="A exact"
                                      value={pointsCalc.fourWeights.aExact}
                                      hideControls
                                      onChange={(value) => {
                                        const updated = [
                                          ...(form.values.commonSettings.general
                                            .moduleSettings.winCondition
                                            .pointsCalc || []),
                                        ];
                                        updated[index] = {
                                          ...updated[index],
                                          fourWeights: {
                                            ...updated[index].fourWeights!,
                                            aExact: value || 0,
                                          },
                                        };
                                        form.setFieldValue(
                                          "commonSettings.general.moduleSettings.winCondition.pointsCalc",
                                          updated
                                        );
                                      }}
                                    />
                                    <NumberInput
                                      label="B exact"
                                      value={pointsCalc.fourWeights.bExact}
                                      hideControls
                                      onChange={(value) => {
                                        const updated = [
                                          ...(form.values.commonSettings.general
                                            .moduleSettings.winCondition
                                            .pointsCalc || []),
                                        ];
                                        updated[index] = {
                                          ...updated[index],
                                          fourWeights: {
                                            ...updated[index].fourWeights!,
                                            bExact: value || 0,
                                          },
                                        };
                                        form.setFieldValue(
                                          "commonSettings.general.moduleSettings.winCondition.pointsCalc",
                                          updated
                                        );
                                      }}
                                    />
                                    <NumberInput
                                      label="A-B exact"
                                      value={pointsCalc.fourWeights.exactMatch}
                                      hideControls
                                      onChange={(value) => {
                                        const updated = [
                                          ...(form.values.commonSettings.general
                                            .moduleSettings.winCondition
                                            .pointsCalc || []),
                                        ];
                                        updated[index] = {
                                          ...updated[index],
                                          fourWeights: {
                                            ...updated[index].fourWeights!,
                                            exactMatch: value || 0,
                                          },
                                        };
                                        form.setFieldValue(
                                          "commonSettings.general.moduleSettings.winCondition.pointsCalc",
                                          updated
                                        );
                                      }}
                                    />
                                  </Group>
                                </div>
                              )}

                            {pointsCalc.type === "DistanceCalculation" &&
                              pointsCalc.distanceCalc && (
                                <div className=" -mx-6 -my-2 p-6">
                                  <Group position="apart" className="w-full">
                                    <Text weight={500} className="text-xl">
                                      Points Calculation #
                                      {pointsCalc.winConditionPointsCalcIndex}
                                    </Text>
                                    <div></div>
                                    <Group spacing="xs">
                                      <ActionIcon
                                        onClick={() =>
                                          handleDuplicatePointsCalc(index)
                                        }
                                      >
                                        <Copy size={20} color="blue" />
                                      </ActionIcon>
                                      <ActionIcon
                                        onClick={() =>
                                          handleRemovePointsCalc(index)
                                        }
                                      >
                                        <Trash color="red" size={20} />
                                      </ActionIcon>
                                    </Group>
                                  </Group>
                                  <Group className="grid grid-cols-6 gap-4 w-full mt-2">
                                    <Select
                                      label="Distance Type"
                                      data={[
                                        {
                                          value: "ValueDistance",
                                          label: "Value Distance",
                                        },
                                      ]}
                                      value={pointsCalc.distanceCalc.type}
                                      onChange={(value) => {
                                        const updated = [
                                          ...(form.values.commonSettings.general
                                            .moduleSettings.winCondition
                                            .pointsCalc || []),
                                        ];
                                        updated[index] = {
                                          ...updated[index],
                                          distanceCalc: {
                                            ...updated[index].distanceCalc!,
                                            type: value || "ValueDistance",
                                          },
                                        };
                                        form.setFieldValue(
                                          "commonSettings.general.moduleSettings.winCondition.pointsCalc",
                                          updated
                                        );
                                      }}
                                      className="col-span-2"
                                    />
                                  </Group>
                                  <Group className="grid grid-cols-8 my-6 gap-4 w-full">
                                    <NumberInput
                                      label="Defined Points Weight"
                                      hideControls
                                      value={
                                        pointsCalc.distanceCalc
                                          .weightsDefinedPoints
                                          ?.definiedPoints || 0
                                      }
                                      onChange={(value) => {
                                        const updated = [
                                          ...(form.values.commonSettings.general
                                            .moduleSettings.winCondition
                                            .pointsCalc || []),
                                        ];
                                        updated[index] = {
                                          ...updated[index],
                                          distanceCalc: {
                                            ...updated[index].distanceCalc!,
                                            weightsDefinedPoints: {
                                              definiedPoints: value || 0,
                                            },
                                          },
                                        };
                                        form.setFieldValue(
                                          "commonSettings.general.moduleSettings.winCondition.pointsCalc",
                                          updated
                                        );
                                      }}
                                    />
                                  </Group>
                                </div>
                              )}

                            {pointsCalc.type === "ExactMatch" && (
                              <div>
                                <Group position="apart" className="w-full">
                                  <Text weight={500} className="text-xl">
                                    Points Calculation #
                                    {pointsCalc.winConditionPointsCalcIndex}
                                  </Text>
                                  <div></div>
                                  <Group spacing="xs">
                                    <ActionIcon
                                      onClick={() =>
                                        handleDuplicatePointsCalc(index)
                                      }
                                    >
                                      <Copy size={20} color="blue" />
                                    </ActionIcon>
                                    <ActionIcon
                                      onClick={() =>
                                        handleRemovePointsCalc(index)
                                      }
                                    >
                                      <Trash color="red" size={20} />
                                    </ActionIcon>
                                  </Group>
                                </Group>
                                <Group className="grid grid-cols-1 w-full mt-2">
                                  <NumberInput
                                    label="Exact Match Points"
                                    hideControls
                                    value={
                                      pointsCalc.exactMatchCalc
                                        ?.exactMatchPoints || 0
                                    }
                                    onChange={(value) => {
                                      const updated = [
                                        ...(form.values.commonSettings.general
                                          .moduleSettings.winCondition
                                          .pointsCalc || []),
                                      ];
                                      updated[index] = {
                                        ...updated[index],
                                        exactMatchCalc: {
                                          exactMatchPoints: value || 0,
                                        },
                                      };
                                      form.setFieldValue(
                                        "commonSettings.general.moduleSettings.winCondition.pointsCalc",
                                        updated
                                      );
                                    }}
                                  />
                                </Group>
                              </div>
                            )}
                          </List.Item>
                        </div>
                      )
                    )}
                  </List>

                  <Group position="center" mt="md" className="gap-4">
                    <Select
                      label="New Calculation Type"
                      value={newPointsCalcType}
                      onChange={(value) => {
                        if (
                          value === "FourWeights" ||
                          value === "DistanceCalculation" ||
                          value === "ExactMatch"
                        ) {
                          setNewPointsCalcType(value);
                        }
                      }}
                      data={[
                        { value: "FourWeights", label: "Four Weights" },
                        {
                          value: "DistanceCalculation",
                          label: "Distance Calculation",
                        },
                        { value: "ExactMatch", label: "Exact Match" },
                      ]}
                      className="w-48"
                    />
                    <Button
                      onClick={handleAddPointsCalc}
                      variant="subtle"
                      leftIcon={<CirclePlus />}
                      className="mt-6"
                    >
                      Add Points Calculation
                    </Button>
                  </Group>
                </div>
              )}
            </div>
          </Collapsable>
          <Group position="center">
            <Button
              className="bg-red-600 w-auto"
              onClick={() => setOpened4(true)}
            >
              Delete
            </Button>
          </Group>
          <Modal
            opened={opened}
            withCloseButton={false}
            padding={0}
            onClose={() => {
              setOpened(false);
            }}
            fullScreen
            radius={0}
          >
            <SubPlaceAdditionForm
              editMode={true}
              setOpened={setOpened}
              place={form.values.commonSettings.general.moduleSettings.place}
              onSaveLocally={
                form.values.commonSettings.general.moduleSettings.place
                  ? (data) => {
                      form.setFieldValue(
                        "commonSettings.general.moduleSettings.place",
                        data
                      );
                    }
                  : undefined
              }
            />
          </Modal>
          <Modal
            opened={opened1}
            withCloseButton={false}
            padding={0}
            onClose={() => {
              setOpened1(false);
            }}
            fullScreen
            radius={0}
          >
            <SubPlaceEditForm
              pronosticV2={pronostic!} // Your PronosticV2 data
              subPlaceTitle={subPlaceTitle}
              subPlaceId={subPlaceId}
              setOpened={setOpened1}
            />
          </Modal>
          <Modal
            opened={opened4}
            onClose={() => setOpened4(false)}
            centered
            radius={0}
            overflow="inside"
            withCloseButton={false}
          >
            <p className="text-xl">Are you sure to delete this pronostic?</p>
            <div className="flex gap-40 mt-6">
              <Button
                style={{ backgroundColor: "#e30613", color: "white" }}
                onClick={() => handleDeletePronostic(pronostic!.id)}
                className="w-24"
              >
                Yes
              </Button>
              <Button
                style={{ color: "white" }}
                onClick={() => setOpened4(false)}
                className="w-24 bg-button-admin"
              >
                No
              </Button>
            </div>
          </Modal>
          <Modal
            opened={opened5}
            withCloseButton={false}
            padding={0}
            onClose={() => {
              setOpened5(false);
              setEditingSlideshowIndex(null);
            }}
            fullScreen
            radius={0}
          >
            <StaffAdditionForm
              editMode={true}
              setOpened={setOpened5}
              workforce={(() => {
                if (editingSlideshowIndex === null) return undefined;

                const element =
                  form.values.commonSettings.general.moduleSettings.pronostics[
                    editingSlideshowIndex
                  ];
                if (element.type === "slideshow") {
                  const slideShow = element as SlideShowElement;
                  // Transform SlideShowElement to WorkforceModel
                  return {
                    id: slideShow.workforceId || uuidv4(), // Use stored workforceId
                    organization: "",
                    name: slideShow.title,
                    players: slideShow.player.map((p, i) => ({
                      id: uuidv4(),
                      name: p.name,
                      logo: p.logo,
                      status: "enabled" as const,
                      index: i + 1,
                    })),
                  };
                }
                return undefined;
              })()}
              onSaveLocally={(data) => {
                let updatedPronostics = [
                  ...form.values.commonSettings.general.moduleSettings
                    .pronostics,
                ];

                if (
                  editingSlideshowIndex !== null &&
                  editingSlideshowIndex < updatedPronostics.length
                ) {
                  const currentElement =
                    updatedPronostics[editingSlideshowIndex];
                  if (currentElement.type === "slideshow") {
                    const currentSlideShow = currentElement as SlideShowElement;

                    const updatedSlideShow: SlideShowElement = {
                      ...currentSlideShow,
                      player: data.players.map((player) => ({
                        name: player.name,
                        logo: player.logo,
                      })),
                      workforceId: data.id, // Store the ID of the workforce
                      // Preserve the title if it was already set, otherwise use the workforce name
                      title: currentSlideShow.title || data.name,
                    };

                    updatedPronostics[editingSlideshowIndex] = updatedSlideShow;

                    form.setFieldValue(
                      "commonSettings.general.moduleSettings.pronostics",
                      updatedPronostics
                    );
                  }
                }
              }}
            />
          </Modal>
        </Stack>
      </PronosticV2FormProvider>
    </>
  );
}
